'use client';

import React from 'react';
import type { BoxProps } from '@chakra-ui/react';
import { Box, Text } from '@chakra-ui/react';

interface CategoryButtonProps extends Omit<BoxProps, 'onClick'> {
  name: string;
  isSelected: boolean;
  onClick: () => void;
}

const CategoryButton = ({ name, isSelected, onClick, ...rest }: CategoryButtonProps) => {
  return (
    <Box
      as="button"
      onClick={onClick}
      paddingX={5}
      paddingY={2.5}
      borderRadius="100px"
      backgroundColor={isSelected ? 'common.100' : 'transparent'}
      borderWidth="1px"
      borderColor={isSelected ? 'transparent' : 'neutral.20'}
      transition="all 0.2s"
      whiteSpace="nowrap"
      cursor="pointer"
      _hover={{
        backgroundColor: isSelected ? 'common.100' : 'rgba(255, 255, 255, 0.05)',
      }}
      {...rest}
    >
      <Text textStyle="body3" fontWeight="regular" color={isSelected ? 'common.0' : 'neutral.10'}>
        {name}
      </Text>
    </Box>
  );
};

export default CategoryButton;
